import { AppDispatch, RootState } from '..';

import { REACT_APP_MANAGE_SERVICE_ENDPOINT } from '../types';
import axios from 'axios';
import { donationType } from '../../types';
import { headers } from '.';
import { notification } from '../../utils';

export const addDonation = (values: donationType) => async (dispatch: AppDispatch, getState: RootState) => {

    const { token } = getState().authReducer;

    const { data } = await axios.post(`${REACT_APP_MANAGE_SERVICE_ENDPOINT}/donation/add`, {...values}, headers(token));

    const { success, message } = data;

    try {

        notification(success ? 'success' : 'error', message);
        
    } catch (error: any) {

        notification(success ? 'success' : 'error', message);
        console.log(error.message);
        
    }

};